import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 80, height: 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { r: 9.5, transform: "matrix(1 0 0 -1 39 37)", stroke: "#CDCDCD", strokeWidth: 3 }), /* @__PURE__ */ React.createElement("line", { x1: 45.5742, y1: 43.1826, x2: 54.331, y2: 51.9395, stroke: "#CDCDCD", strokeWidth: 3 }));
const ForwardRef = forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
